import PropTypes from "prop-types";

export default function ItemCard({ item, onOpen, onCopy }) {
    const entityTypes = Array.isArray(item.entityTypes) ? item.entityTypes : [];

    const initial = (item.name || item.systemName || "?")
        .toString()
        .trim()
        .charAt(0)
        .toUpperCase();

    return (
        <article className="card item-card">
            <div className="card-body">
                {/* Header */}
                <header className="item-card__header">
                    <div className="item-card__title-block">
                        <div className="item-card__avatar">
                            <span>{initial}</span>
                        </div>
                        <div>
                            <h2 className="card-title item-card__title">
                                {item.name}
                            </h2>
                            <p className="card-subtle">
                                {item.systemName}
                            </p>
                        </div>
                    </div>
                </header>

                {/* Description */}
                {item.description && (
                    <p className="card-section muted item-card__description">
                        {item.description}
                    </p>
                )}

                {/* Entity types */}
                {entityTypes.length > 0 && (
                    <div className="item-card__tags">
                        {entityTypes.map((entityType) => (
                            <span key={entityType} className="chip">
                                {entityType}
                            </span>
                        ))}
                    </div>
                )}

                {/* Footer */}
                <footer className="item-card__footer">
                    <button
                        className="btn btn-outline"
                        onClick={() => onOpen?.(item)}
                    >
                        Открыть
                    </button>
                    <button
                        className="btn btn-soft-accent"
                        onClick={() => onCopy?.(item)}
                    >
                        Копировать
                    </button>
                </footer>
            </div>
        </article>
    );
}

ItemCard.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        systemName: PropTypes.string.isRequired,
        name: PropTypes.string,
        description: PropTypes.string,
        entityTypes: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    onOpen: PropTypes.func,
    onCopy: PropTypes.func,
};
